export const DateRangeSelector = Backbone.Marionette.Layout.extend({
    template: '#tpl_dashboard_project_compliance_date_range_selector',
    className: 'card',

    title: null, // string

    saveDateRange: null, // function

    events: {
        'click .email_radio': 'setDateRange'
    },

    initialize: function (options) {
        options = options || {};
        this.validateRequiredArguments(options);
        $.extend(this, options);
    },

    validateRequiredArguments: function (options) {
        const { title, saveDateRange } = options;
        const requiredFields = [title, saveDateRange];

        if (requiredFields.some(_.isUndefined)) {
            throw new Error('Programmer Error: DateRangeSelector must have a title and saveDateRange');
        }
    },

    templateHelpers: function () {
        return {
            title: this.title
        };
    },

    setDateRange: function (email) {
        const selectedDateRangeRadio = this.$('.email_radio:checked');

        this.saveDateRange(selectedDateRangeRadio.val());
    }
});
